import { Record } from 'immutable';
import { resolve } from '../helpers/LinkMapper';

const PassengerRailcard = new Record({
    code: '',
    quantity: 1
});

PassengerRailcard.fromJSON = function(json = {}) {
    return new PassengerRailcard({
        code: resolve(json.code).with(String),
        quantity: resolve(json.quantity).with(Number)
    });
};

export default PassengerRailcard;
